/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectSportQueryVariables = {||};
export type SelectSportQueryResponse = {|
  +sportsWithSlates: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>
|};
export type SelectSportQuery = {|
  variables: SelectSportQueryVariables,
  response: SelectSportQueryResponse,
|};
*/


/*
query SelectSportQuery {
  sportsWithSlates {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SportType",
    "kind": "LinkedField",
    "name": "sportsWithSlates",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectSportQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SelectSportQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "afc22bb7f9d18f8701ba1d747b6aed6c",
    "id": null,
    "metadata": {},
    "name": "SelectSportQuery",
    "operationKind": "query",
    "text": "query SelectSportQuery {\n  sportsWithSlates {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ab9b82f97bd513a8589f2be7d3d75a43';

module.exports = node;
